module.exports = __webpack_public_path__ + "img/hero.d2efeb62.png";